import { c as _c } from "react/compiler-runtime";
import { Pagination } from 'platform/components';
import { useIsMobileView } from '../../hooks/useIsMobileView';
import { useIsTabletView } from './hooks/useIsTabletView';
type PaginationProps = {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
};

/**
 * Pagination control for the EagGrid footer.
 *
 * ## Layout behaviour
 *
 * - **Mobile / tablet** (≤ 1024 px): fixed footer strip anchored to the bottom of
 *   the viewport, full width with 8px inset. Solid white background with shadow.
 *
 * - **Desktop / notebook** (> 1024 px): floated glass overlay in the bottom-right
 *   corner of the grid. Uses `position: absolute` so the grid content scrolls
 *   beneath it. The backdrop-blur creates a frosted-glass effect so partially
 *   obscured data rows remain legible through the overlay.
 *   The parent container in `EagGridTable` must have `position: relative` for
 *   this to anchor correctly.
 */
export function GridPagination(props) {
  const $ = _c(8);
  const isMobile = useIsMobileView();
  const isTablet = useIsTabletView();
  const isMobileOrTablet = isMobile || isTablet;
  if (props.totalPages <= 1) {
    return null;
  }
  if (isMobileOrTablet) {
    let t0;
    if ($[0] !== props.currentPage || $[1] !== props.onPageChange || $[2] !== props.totalPages) {
      t0 = <div className="fixed bottom-2 left-2 right-2 bg-white rounded-lg shadow-sm px-3 py-2 flex items-center justify-center z-(--z-header) [&_*:focus-visible]:!outline-none [&_*:focus]:!outline-none"><Pagination page={props.currentPage} pagesQuantity={props.totalPages} onPageChange={props.onPageChange} showPrevButton={true} showNextButton={true} /></div>;
      $[0] = props.currentPage;
      $[1] = props.onPageChange;
      $[2] = props.totalPages;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== props.currentPage || $[5] !== props.onPageChange || $[6] !== props.totalPages) {
    t0 = <div className="absolute bottom-2 right-3 bg-white/85 backdrop-blur-md rounded-lg shadow-sm px-3 py-2 flex items-center z-(--z-content-loader) [&_*:focus-visible]:!outline-none [&_*:focus]:!outline-none"><Pagination page={props.currentPage} pagesQuantity={props.totalPages} onPageChange={props.onPageChange} showPrevButton={true} showNextButton={true} /></div>;
    $[4] = props.currentPage;
    $[5] = props.onPageChange;
    $[6] = props.totalPages;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}